// Karsilama kartinin alan listesi, dogrulamasi ve gonderim yuku.
// Saf tutuldu: hem webpack hem `node --test` okuyor, o yuzden CommonJS.

// Alan tipi -> kartta cizilecek input bileseni.
const INPUT_BY_TYPE = {
    email: "email",
    phone: "phone",
    select: "select",
    check: "check",
    numeric: "numeric",
    label: "note",
    rich: "note",
    language: "language",
    city: "city",
    subject: "select",
};

const EMAIL_RE = /^[^@\s]+@[^@\s.]+\.[^@\s]+$/;
const NUMERIC_RE = /^-?\d+([.,]\d+)?$/;
// En az 7 rakam; ulke kodu ve ayirici serbest.
const PHONE_RE = /^[+]?[\d\s()-]{7,}$/;

// Il/ilce tek alanda kaydediliyor ama iki input olarak soruluyor.
const DISTRICT_SUFFIX = "__district";

// Panelde etiket her dilde dolu olmayabiliyor: locale -> en -> tr -> ilk dil.
// API etiketleri DIZI olarak donuyor ([{text, languageCode}]); onceki surum
// Object.keys ile dil kodu ariyordu, dizide bu indeks veriyor ve etiket hep
// ILK dilde kaliyordu. Iki sekil de destekleniyor.
function localizedInputLabel(input, locale) {
    const labels = (input && input.localizedLabel) || {};
    const byCode = {};
    if (Array.isArray(labels)) {
        labels.forEach((x) => {
            if (x && x.languageCode) byCode[x.languageCode] = x;
        });
    } else {
        Object.keys(labels).forEach((code) => {
            if (labels[code]) byCode[code] = labels[code];
        });
    }
    const langs = Object.keys(byCode);
    if (!langs.length) return "";
    const fallback = langs.includes("en") ? "en" : langs.includes("tr") ? "tr" : langs[0];
    const lang = langs.includes(locale) ? locale : fallback;
    const value = byCode[lang];
    return (value && value.text) || "";
}

// Panelde etiketler zengin metin editorunden geliyor ("<p>Phone</p>" gibi).
// Aciklama ve onay metinleri v-html ile basiliyor, ama satir ici <label> ve
// input attribute'lari duz metin ister; orada isaretleme oldugu gibi goruntulenirdi.
const ENTITIES = { amp: "&", lt: "<", gt: ">", quot: '"', apos: "'", nbsp: " ", "#39": "'", "#x27": "'" };

function plainLabel(html) {
    if (!html) return "";
    return String(html)
        // Etiket siniri kelime siniridir: <p>Ad</p><p>Soyad</p> -> "Ad Soyad"
        .replace(/<[^>]*>/g, " ")
        .replace(/&(#x?[0-9a-fA-F]+|[a-zA-Z]+);/g, (tam, ad) => {
            const duz = ENTITIES[ad.toLowerCase()];
            if (duz !== undefined) return duz;
            const sayisal = /^#x/i.test(ad)
                ? parseInt(ad.slice(2), 16)
                : /^#/.test(ad)
                ? parseInt(ad.slice(1), 10)
                : NaN;
            return isNaN(sayisal) ? tam : String.fromCodePoint(sayisal);
        })
        .replace(/\s+/g, " ")
        .trim();
}

// Ozel formda departman alani var mi? Form artik login'den ONCE gonderildigi
// icin departman kartta soruluyor ve subjectId konusma olusurken hazir oluyor.
function hasSubjectInput(inputs) {
    return (inputs || []).some((x) => x && x.visible && x.type === "subject");
}

function buildFields({ customLoginFormEnabled, inputs, locale, departmentEnabled, hasSubjects } = {}) {
    if (!customLoginFormEnabled) {
        const builtin = [
            {
                id: "fullname",
                type: "fullname",
                input: "text",
                required: true,
                labelKey: "message.welcomeFieldFullname",
            },
            { id: "email", type: "email", input: "email", required: true, labelKey: "message.welcomeFieldEmail" },
            { id: "phone", type: "phone", input: "phone", required: false, labelKey: "message.welcomeFieldPhone" },
        ];
        // Departman formun parcasi: atama algoritmasi konusma olusurken buna bakiyor.
        if (departmentEnabled && hasSubjects) {
            builtin.push({
                id: "subject",
                type: "subject",
                input: "select",
                required: true,
                labelKey: "message.welcomeAskSubject",
            });
        }
        return builtin;
    }

    const fields = [];
    (inputs || [])
        .filter((input) => input && input.visible)
        .forEach((input) => {
            const field = {
                id: input._id,
                sourceId: input._id,
                type: input.type,
                input: INPUT_BY_TYPE[input.type] || "text",
                required: !!input.required,
                label: localizedInputLabel(input, locale),
                options: input.options || null,
            };
            if (input.type === "cityAndDistrict") {
                fields.push({ ...field, input: "city" });
                fields.push({ ...field, id: input._id + DISTRICT_SUFFIX, input: "district" });
                return;
            }
            fields.push(field);
        });
    return fields;
}

// Katlanmis kartta tek alan gorunur: kisiyi tanitan alan one cikar.
// Onceden "ilk bos alan" secliyordu; ad/eposta dolu gelince geriye onay
// kutusu kaliyor ve kart anlamsiz gorunuyordu.
const COMPACT_PRIORITY = ["fullname", "email", "phone"];

function pickCompactField(fields) {
    const list = (fields || []).filter((f) => f && f.input !== "note" && f.input !== "check");
    const priority = COMPACT_PRIORITY.map((type) => list.find((f) => f.type === type)).find(Boolean);
    // Form yalnizca onay/aciklama tasiyorsa: once onay, sonra ilk alan.
    const rest = (fields || []).filter((f) => f && f.input !== "note");
    return priority || list[0] || rest[0] || (fields || [])[0] || null;
}

// Donen deger i18n anahtarinin son parcasi; metin bilesende cozuluyor.
function validateField(field, value) {
    const type = (field && field.type) || "text";
    const required = !!(field && field.required);
    if (type === "check") return required && value !== true ? "required" : null;

    const text = value === null || value === undefined ? "" : String(value).trim();
    if (!text) return required ? "required" : null;
    if (type === "email" && !EMAIL_RE.test(text)) return "email";
    if (type === "numeric" && !NUMERIC_RE.test(text)) return "numeric";
    if (type === "phone" && !PHONE_RE.test(text)) return "phone";
    return null;
}

// Il ve ilce iki inputta toplaniyor, tek alanda "Il/Ilce" olarak kaydediliyor.
function collectValue(input, values) {
    if (input.type === "cityAndDistrict") {
        const city = values[input._id];
        const district = values[input._id + DISTRICT_SUFFIX];
        if (city && district) return city + "/" + district;
        return city;
    }
    return values[input._id];
}

function buildWelcomePayload({ fields, values, base, inputs } = {}) {
    const answers = values || {};
    const { visitorId, siteId, conversationId, customLoginFormEnabled } = base || {};
    const common = { visitorId, siteId, conversationId };

    if (!customLoginFormEnabled) {
        return {
            ...common,
            fullname: answers.fullname,
            email: answers.email,
            phone: answers.phone,
        };
    }

    // Sekil birebir korunuyor: gizli alanlar ve aciklama bloklari da degersiz gidiyor.
    return {
        ...common,
        customLoginForm: true,
        customLoginFormValues: (inputs || []).map((input) => ({
            input: input._id,
            value: collectValue(input, answers),
        })),
    };
}

// Form login'den ONCE gonderiliyor: bu yuk dogrudan "visitor login" cagrisina
// giriyor, boylece atama algoritmasi ve chatbot attribute'lari konusma
// olusurken tum veriye sahip oluyor.
function buildLoginData({ fields, values, inputs, customLoginFormEnabled } = {}) {
    const answers = values || {};
    if (!customLoginFormEnabled) {
        return {
            fullname: answers.fullname,
            email: answers.email,
            phone: answers.phone,
            // Departmanin etiketi degil id'si gidiyor.
            subjectId: answers.subject,
        };
    }
    const subjectInput = (inputs || []).find((x) => x && x.type === "subject");
    return {
        customLoginForm: true,
        customLoginFormValues: (inputs || []).map((input) => ({
            input: input._id,
            value: collectValue(input, answers),
        })),
        subjectId: subjectInput ? answers[subjectInput._id] : undefined,
    };
}

module.exports = {
    plainLabel,
    INPUT_BY_TYPE,
    hasSubjectInput,
    DISTRICT_SUFFIX,
    localizedInputLabel,
    buildFields,
    pickCompactField,
    validateField,
    buildWelcomePayload,
    buildLoginData,
};



// WEBPACK FOOTER //
// ./src/utils/welcomeFields.js